<template>
    <div class="pageIndex" :class="isRestrictedTestUi ? 'pageIndex--mode-a' : 'pageIndex--mode-b'">
        <div class="jobMain">
            <div class="loginIntro">
                <template v-if="!isRestrictedTestUi">
                    <div class="loginIntro-tle">潞安化工集团{{ currentYear }}年校园招聘系统</div>
                    <div class="loginIntro-m">潞安化工集团是“十四五”山西省委、省政府在推动新一轮国资国企改革、深化能源领域战略性重组中，新设成立的山西省属重点国有企业。2020 年 7 月，开始组建，注册资本 200 亿元，2020 年 11 月 26 日正式挂牌。目前，集团所属各级控股子公司 166 户、参股子公司 55户，分公司 88 户，业务覆盖山西、山东、河北、北京、上海、广东、江苏、新疆等 10 多个省（区、市），含潞安环能、潞化科技 2 个上市公司，职工约 12 万人。拥有7 个国家级创新平台、15 户国家高新技术企业、20 个省级科技创新机构。集团公司入选国务院国资委“国有企业公司治理示范企业”，2025 年集团营业收入 1190 亿元。</div>
                </template>
                <template v-else>
                    <div class="loginIntro-tle">招聘测试招聘系统</div>
                    <div class="loginIntro-m loginIntro-m--test">测试系统</div>
                </template>
            </div>
            <div class="login-m">
                <div class="login-mt"><i class="el-icon-user"></i> <template v-if="!isRestrictedTestUi">潞安化工招聘报名系统</template><template v-else>招聘测试招聘报名系统</template></div>
                <div class="login-mb" v-if="loginFlag==0">
                    <div class="login-mb-l" v-if="entryList.length">
                        <div
                            class="login-mb-lg"
                            v-for="item in entryList"
                            :key="item.id"
                            :class="lgNum === item.entranceType ? 'login-mb-lgact' : ''"
                            v-on:click="changeLgNum(item.entranceType)"
                        >
                            <div>
                                <svg v-if="item.entranceType === 0" t="1766451071231" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1680" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20"><path d="M512 634.603243c-19.64973 0-38.745946-4.621838-53.773838-13.007567L48.515459 392.164324C26.485622 379.904 13.837838 360.198919 13.837838 338.196757c0-22.057514 12.647784-41.762595 34.705297-54.078271l409.683027-229.348324c29.972757-16.799135 77.491892-16.826811 107.575352 0l409.710702 229.348324c22.029838 12.343351 34.649946 32.048432 34.649946 54.105946 0 22.029838-12.647784 41.707243-34.677621 54.022919l-409.710703 229.348325c-15.000216 8.413405-34.096432 13.035243-53.773838 13.035243zM116.099459 338.141405l381.426163 213.545514c2.490811 1.383784 7.915243 2.767568 14.474378 2.767567 7.500108 0 12.647784-1.743568 14.474378-2.767567l381.453838-213.545514-381.426162-213.517837c-2.490811-1.383784-7.942919-2.767568-14.502054-2.767568-7.472432 0-12.620108 1.715892-14.446703 2.767568L116.099459 338.141405z m396.038919 589.602595c-169.292108 0-341.18573-53.967568-348.879567-157.197838a39.465514 39.465514 0 0 1-0.553514-6.642162V459.250162c0-22.140541 17.989189-40.074378 40.157406-40.074378a40.12973 40.12973 0 0 1 40.157405 40.074378V759.143784c0.166054 1.411459 0.276757 2.87827 0.276757 4.345081 0.332108 29.668324 102.649081 84.134054 268.813838 84.134054 166.192432 0 268.48173-54.46573 268.786162-84.134054l0.055351-1.632865V459.222486c0-22.140541 17.989189-40.074378 40.157406-40.074378 22.195892 0 40.157405 17.961514 40.157405 40.074378v304.70919c0 1.051676-0.027676 2.075676-0.110703 3.127351-4.040649 105.499676-177.871568 160.684973-349.045621 160.684973z m452.082163-104.198919a40.12973 40.12973 0 0 1-40.12973-40.074378V465.394162c0-22.140541 17.961514-40.074378 40.12973-40.074378 22.195892 0 40.157405 17.933838 40.157405 40.074378v318.076541c0 22.140541-17.989189 40.074378-40.12973 40.074378z" :fill="lgNum === 0 ? '#E7000B' : '#99A1AF'" p-id="1681"></path></svg>
                                <svg v-else-if="item.entranceType === 1" t="1766451948305" class="icon" viewBox="0 0 1248 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="40261" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="20"><path d="M807.328 933.888c-25.312 0-42.176-16.864-42.176-42.176v-84.384c0-71.712-54.848-126.56-126.56-126.56H301.088c-71.712 0-126.56 54.848-126.56 126.56v84.384c0 25.312-16.864 42.176-42.176 42.176s-42.176-16.864-42.176-42.176v-84.384c0-118.112 92.8-210.944 210.944-210.944h337.504c118.112 0 210.944 92.8 210.944 210.944v84.384c0 25.312-16.864 42.176-42.176 42.176zM469.824 512c-118.112 0-210.944-92.8-210.944-210.944s92.8-210.944 210.944-210.944 210.944 92.8 210.944 210.944S587.968 512 469.824 512z m0-337.504c-71.712 0-126.56 54.848-126.56 126.56s54.848 126.56 126.56 126.56 126.56-54.848 126.56-126.56-54.848-126.56-126.56-126.56z m590.624 759.392c-25.312 0-42.176-16.864-42.176-42.176v-84.384c0-59.072-37.984-109.696-92.8-122.336-21.088-4.224-37.984-29.536-29.536-50.624 4.224-21.088 29.536-37.984 50.624-29.536 92.8 25.312 156.096 109.696 160.32 202.496v84.384c-4.224 25.312-21.088 42.176-46.4 42.176zM765.12 507.776c-16.864 0-37.984-12.672-42.176-33.76s8.448-46.4 29.536-50.624c46.4-12.672 80.16-46.4 92.8-92.8 16.864-67.488-25.312-135.008-92.8-156.096-21.088 0-33.76-25.312-29.536-46.4s29.536-37.984 50.624-29.536c113.92 29.536 181.408 143.424 151.872 257.344-21.088 75.936-75.936 135.008-151.872 151.872h-8.448z" :fill="lgNum === 1 ? '#E7000B' : '#99A1AF'" p-id="40262"></path></svg>
                                <i v-else class="el-icon-user" style="font-size: 20px; font-weight: 500;"></i>
                            </div>
                            <div class="login-mb-lg-label">{{ item.label }}</div>
                            <div class="login-mb-lg-time">报名时间：{{ item.timeText }}</div>
                        </div>
                    </div>
                    <div class="login-mb-r" v-if="entryList.length">
                        <div class="login-mb-rt clearfix">
                            <span class="login-mb-rticon">
                                <svg v-if="lgNum === 0" t="1766451071231" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1680" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20"><path d="M512 634.603243c-19.64973 0-38.745946-4.621838-53.773838-13.007567L48.515459 392.164324C26.485622 379.904 13.837838 360.198919 13.837838 338.196757c0-22.057514 12.647784-41.762595 34.705297-54.078271l409.683027-229.348324c29.972757-16.799135 77.491892-16.826811 107.575352 0l409.710702 229.348324c22.029838 12.343351 34.649946 32.048432 34.649946 54.105946 0 22.029838-12.647784 41.707243-34.677621 54.022919l-409.710703 229.348325c-15.000216 8.413405-34.096432 13.035243-53.773838 13.035243zM116.099459 338.141405l381.426163 213.545514c2.490811 1.383784 7.915243 2.767568 14.474378 2.767567 7.500108 0 12.647784-1.743568 14.474378-2.767567l381.453838-213.545514-381.426162-213.517837c-2.490811-1.383784-7.942919-2.767568-14.502054-2.767568-7.472432 0-12.620108 1.715892-14.446703 2.767568L116.099459 338.141405z m396.038919 589.602595c-169.292108 0-341.18573-53.967568-348.879567-157.197838a39.465514 39.465514 0 0 1-0.553514-6.642162V459.250162c0-22.140541 17.989189-40.074378 40.157406-40.074378a40.12973 40.12973 0 0 1 40.157405 40.074378V759.143784c0.166054 1.411459 0.276757 2.87827 0.276757 4.345081 0.332108 29.668324 102.649081 84.134054 268.813838 84.134054 166.192432 0 268.48173-54.46573 268.786162-84.134054l0.055351-1.632865V459.222486c0-22.140541 17.989189-40.074378 40.157406-40.074378 22.195892 0 40.157405 17.961514 40.157405 40.074378v304.70919c0 1.051676-0.027676 2.075676-0.110703 3.127351-4.040649 105.499676-177.871568 160.684973-349.045621 160.684973z m452.082163-104.198919a40.12973 40.12973 0 0 1-40.12973-40.074378V465.394162c0-22.140541 17.961514-40.074378 40.12973-40.074378 22.195892 0 40.157405 17.933838 40.157405 40.074378v318.076541c0 22.140541-17.989189 40.074378-40.12973 40.074378z" fill="#E7000B" p-id="1681"></path></svg>
                                <svg v-else-if="lgNum === 1" t="1766451948305" class="icon" viewBox="0 0 1248 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="40261" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="20"><path d="M807.328 933.888c-25.312 0-42.176-16.864-42.176-42.176v-84.384c0-71.712-54.848-126.56-126.56-126.56H301.088c-71.712 0-126.56 54.848-126.56 126.56v84.384c0 25.312-16.864 42.176-42.176 42.176s-42.176-16.864-42.176-42.176v-84.384c0-118.112 92.8-210.944 210.944-210.944h337.504c118.112 0 210.944 92.8 210.944 210.944v84.384c0 25.312-16.864 42.176-42.176 42.176zM469.824 512c-118.112 0-210.944-92.8-210.944-210.944s92.8-210.944 210.944-210.944 210.944 92.8 210.944 210.944S587.968 512 469.824 512z m0-337.504c-71.712 0-126.56 54.848-126.56 126.56s54.848 126.56 126.56 126.56 126.56-54.848 126.56-126.56-54.848-126.56-126.56-126.56z m590.624 759.392c-25.312 0-42.176-16.864-42.176-42.176v-84.384c0-59.072-37.984-109.696-92.8-122.336-21.088-4.224-37.984-29.536-29.536-50.624 4.224-21.088 29.536-37.984 50.624-29.536 92.8 25.312 156.096 109.696 160.32 202.496v84.384c-4.224 25.312-21.088 42.176-46.4 42.176zM765.12 507.776c-16.864 0-37.984-12.672-42.176-33.76s8.448-46.4 29.536-50.624c46.4-12.672 80.16-46.4 92.8-92.8 16.864-67.488-25.312-135.008-92.8-156.096-21.088 0-33.76-25.312-29.536-46.4s29.536-37.984 50.624-29.536c113.92 29.536 181.408 143.424 151.872 257.344-21.088 75.936-75.936 135.008-151.872 151.872h-8.448z" fill="#E7000B" p-id="40262"></path></svg>
                                <i v-else class="el-icon-user" style="font-size: 20px; color: #E7000B; font-weight: 600;"></i>
                            </span>
                            <div class="login-mb-rt-body">
                                <div class="login-mb-rt-title">{{ currentEntry.label }}登录</div>
                            </div>
                        </div>
                        <div class="login-mb-rtips">请输入您的手机号和验证码</div>
                        <div class="login-mb-rli"><el-input size="large" placeholder="请输入手机号" prefix-icon="el-icon-mobile" v-model="username"></el-input></div>
                        <div class="login-mb-rli">
                            <el-row :gutter="10" class="login-mb-codeRow">
                                <el-col :span="12">
                                    <el-input size="large" placeholder="请输入密码" prefix-icon="el-icon-chat-square" v-model="password" @keyup.enter.native="codeLogin"></el-input>
                                </el-col>
                                <el-col :span="12">
                                    <el-button size="large" type="danger" plain  @click="startCountdown" :disabled="isCounting" style="width: 100%;">{{ buttonText }}</el-button>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="login-mb-rli">
<!--                            <button class="login-btn" @click="login">密码登录</button>-->
                            <button class="login-btn" @click="codeLogin">验证码登录</button>
                        </div>
                        <div class="login-mb-rtips">未注册手机号登录时将自动创建账号</div>
                    </div>
                    <div class="login-mb-entry-hint" v-if="entryLoading">入口配置加载中...</div>
                    <div class="login-mb-entry-hint" v-else-if="!entryList.length">暂未开放报名入口，请稍后再试</div>
                </div>
                <div class="login-mb" v-if="loginFlag==1" style="padding: 0 24px;">
                    <div class="login-m-avatar">
                        <div class="avatar-circle">
                            <i class="avatar-login-success"></i>
                            <el-avatar :size="60" :src="userInfo.avatar ? userInfo.avatar : circleUrl"></el-avatar>
                        </div>
                    </div>
                    <div class="avatar-userName">欢迎，{{userInfo.username}}</div>
                    <div class="avatar-userId">ID:{{userInfo.id}}</div>
                    <div v-if="userInfo.roleId===2">
                        <div class="login-status-1" :class="loginBorder[userInfo.status]">
                            <span class="ls1-tle">当前状态：</span>
                            <span class="ls1-r ls1-r5" v-if="spStatus==5"><i class="el-icon-edit"></i> 待签名</span>
                            <span class="ls1-r ls1-r0" v-if="spStatus==0"><i class="el-icon-warning-outline"></i> 未报名</span>
                            <span class="ls1-r ls1-r1" v-if="spStatus==1"><i class="el-icon-refresh-left"></i> 资格审查中</span>
                            <span class="ls1-r ls1-r2" v-if="spStatus==2"><i class="el-icon-warning-outline"></i> 需补充资料</span>
                            <span class="ls1-r ls1-r3" v-if="spStatus==3"><i class="el-icon-circle-check"></i> 资格审查通过</span>
                            <span class="ls1-r ls1-r4" v-if="spStatus==4"><i class="el-icon-circle-close"></i> 资格审查未通过</span>
                        </div>
                        <div class="job-link">
                            <router-link to="pageRegLink" class="job-link-btn">浏览专业 / 立即报名</router-link>
                        </div>
                        <div class="login-status-2">
                            <ul class="ls2-list">
                                <li><span class="ls2-libox" :class="spStatus==5 ? 'ls25' : ''">待签名</span></li>
                                <li><span class="ls2-libox" :class="spStatus==0 ? 'ls20' : ''">未报名</span></li>
                                <li><span class="ls2-libox" :class="spStatus==1 ? 'ls21' : ''">审查中</span></li>
                                <li><span class="ls2-libox" :class="spStatus==2 ? 'ls22' : ''">补资料</span></li>
                                <li><span class="ls2-libox" :class="spStatus==3 ? 'ls23' : ''">通过</span></li>
                                <li><span class="ls2-libox" :class="spStatus==4 ? 'ls24' : ''">未通过</span></li>
                            </ul>
                        </div>
                    </div>
                    <div class="loginOut" @click="loginOut">
                        <span style="vertical-align: middle; margin-right: 5px;"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 12 12" fill="none">
                            <path d="M8 8.5L10.5 6L8 3.5" stroke="#99A1AF" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M10.5 6H4.5" stroke="#99A1AF" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M4.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H4.5" stroke="#99A1AF" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg></span><span>退出当前账号</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Cookies from 'js-cookie'

/** 中国大陆手机号：1 开头，第二位 3-9，共 11 位 */
const PHONE_REG = /^1[3-9]\d{9}$/;
/** 测试/白名单手机号，跳过格式校验 */
const PHONE_WHITELIST = ['10000000000', '10000000001'];

export default {
    name: 'PageIndex',
    inject: {
        recruitmentUi: {
            default: () => ({ verifyMode: 'B', loaded: false }),
        },
    },
    data() {
        return {
            circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
            loginFlag: 0,
            userInfo: {},
            loginBorder: {0: 'ls10', 1: 'ls11', 2: 'ls12', 3: 'ls13', 4: 'ls14'},
            /** 当前选中的入口类别，与后端 entranceType 一致：0优培 1技术 2操作 */
            lgNum: null,
            entryList: [],
            entryLoading: false,
            spStatus: 0,
            username: '',
            password: '',
            countdownTime: 60, // 倒计时时间，单位为秒
            isCounting: false, // 控制按钮是否处于倒计时状态
            countdownTimer: null,
            /** 手机号是否为管理员的查询缓存 */
            adminPhoneCache: {},
        }
    },
    computed: {
        currentYear() {
            return new Date().getFullYear();
        },
        isRestrictedTestUi() {
            return this.recruitmentUi && this.recruitmentUi.verifyMode === 'A'
        },
        buttonText() {
            return this.isCounting ? `${this.countdownTime}秒后重新获取` : '获取验证码';
        },
        currentEntry() {
            if (!this.entryList.length) {
                return { label: '', timeText: '' };
            }
            const matched = this.entryList.find((item) => item.entranceType === this.lgNum);
            return matched || this.entryList[0];
        },
    },
    mounted() {
        document.title = '潞安招聘-首页';
        this.loadEntryList();
        this.getUserInfo();
    },
    beforeDestroy() {
        if (this.countdownTimer) {
            clearInterval(this.countdownTimer);
            this.countdownTimer = null;
        }
    },
    methods: {
        apiOk(res) {
            const d = res.data;
            return d && (d.success === true || d.code === 200);
        },
        /** Element UI $alert 点击右上角关闭时会 reject，需吞掉避免 dev overlay 报错 */
        showAlert(message, title, options) {
            return this.$alert(message, title, options).catch(() => {});
        },
        /**
         * 后端 approvalStatus：0-待签名，1-需补充资料，2-审批中，3-已通过，4-审核不通过
         * 首页 spStatus：0-未报名，5-待签名，1-审查中，2-补资料，3-通过，4-未通过
         */
        mapApprovalStatusToSpStatus(approvalStatus) {
            const status = Number(approvalStatus);
            const map = {
                0: 5,
                1: 2,
                2: 1,
                3: 3,
                4: 4,
            };
            return map[status] != null ? map[status] : 0;
        },
        resolveLatestApplication(list) {
            if (!Array.isArray(list) || !list.length) {
                return null;
            }
            return list.slice().sort((a, b) => {
                const ta = new Date(a.createdAt || a.created_at || 0).getTime();
                const tb = new Date(b.createdAt || b.created_at || 0).getTime();
                return tb - ta;
            })[0];
        },
        normalizeEntryList(data) {
            if (Array.isArray(data)) {
                return data;
            }
            if (data && Array.isArray(data.records)) {
                return data.records;
            }
            return [];
        },
        formatEntryTimeRange(item) {
            const b = item.beginDate ? this.$moment(item.beginDate).format('M月D日 HH:mm') : '';
            const e = item.endDate ? this.$moment(item.endDate).format('M月D日 HH:mm') : '';
            if (b && e) {
                return `${b} - ${e}`;
            }
            return b || e || '-';
        },
        formatOpenTimeRange(item) {
            const b = item.beginDate ? this.$moment(item.beginDate).format('M月D日 HH:mm') : '';
            const e = item.endDate ? this.$moment(item.endDate).format('M月D日 HH:mm') : '';
            if (b && e) {
                return `${b} 至 ${e}`;
            }
            return b || e || '-';
        },
        isEntranceInOpenTime(entry) {
            if (!entry || !entry.beginDate || !entry.endDate) {
                return true;
            }
            const now = this.$moment();
            const begin = this.$moment(entry.beginDate);
            const end = this.$moment(entry.endDate);
            return !now.isBefore(begin) && !now.isAfter(end);
        },
        isAdminPhone(phone) {
            const cached = this.adminPhoneCache[phone];
            if (cached !== undefined) {
                return Promise.resolve(cached);
            }
            return axios.get('/zhaopinapi/users/is-admin-phone', {
                params: { phone },
            }).then((res) => {
                const isAdmin = this.apiOk(res) && res.data.data === true;
                this.adminPhoneCache[phone] = isAdmin;
                return isAdmin;
            }).catch(() => false);
        },
        validateEntranceOpenTime() {
            if (this.lgNum === null || this.lgNum === undefined || this.lgNum === '') {
                this.$message.warning('请选择报名入口');
                return Promise.resolve(false);
            }
            const phone = String(this.username || '').trim();
            if (!phone) {
                this.$message.error('请输入手机号');
                return Promise.resolve(false);
            }
            if (PHONE_WHITELIST.includes(phone)) {
                return Promise.resolve(true);
            }
            return this.isAdminPhone(phone).then((isAdmin) => {
                if (isAdmin) {
                    return true;
                }
                const entry = this.currentEntry;
                if (this.isEntranceInOpenTime(entry)) {
                    return true;
                }
                return this.checkPhoneEntranceApplied(phone, this.lgNum).then((result) => {
                    if (result.hasApplied) {
                        return true;
                    }
                    if (result.apiFailed) {
                        this.showAlert('校验报名信息失败，请稍后重试或联系管理员', '提示', {
                            confirmButtonText: '我知道了',
                            type: 'warning',
                        });
                        return false;
                    }
                    const range = this.formatOpenTimeRange(entry);
                    this.showAlert(`不在开放时间内，开放时间：${range}`, '提示', {
                        confirmButtonText: '我知道了',
                        type: 'warning',
                    });
                    return false;
                });
            });
        },
        checkPhoneEntranceApplied(phone, entranceType) {
            if (!phone || entranceType === null || entranceType === undefined || entranceType === '') {
                return Promise.resolve({ ok: false, hasApplied: false, apiFailed: false });
            }
            return axios.get('/zhaopinapi/job-applications/check-phone-entrance-applied', {
                params: {
                    phone,
                    entranceType: Number(entranceType),
                },
            }).then((res) => {
                const d = res && res.data;
                if (!d) {
                    return { ok: false, hasApplied: false, apiFailed: true };
                }
                if (d.code === 200 || d.success === true) {
                    const hasApplied = d.data === true || d.data === 'true' || d.data === 1;
                    return { ok: true, hasApplied, apiFailed: false };
                }
                return { ok: false, hasApplied: false, apiFailed: true };
            }).catch(() => ({ ok: false, hasApplied: false, apiFailed: true }));
        },
        mapEntranceItem(row) {
            return {
                id: row.id,
                entranceType: Number(row.entranceType),
                label: row.entranceName,
                timeText: this.formatEntryTimeRange(row),
                beginDate: row.beginDate,
                endDate: row.endDate,
            };
        },
        loadEntryList() {
            this.entryLoading = true;
            axios.get('/zhaopinapi/entrance/find-all').then((res) => {
                if (this.apiOk(res)) {
                    const list = this.normalizeEntryList(res.data.data)
                        .map((row) => this.mapEntranceItem(row))
                        .sort((a, b) => a.id - b.id);
                    this.entryList = list;
                    if (list.length) {
                        const stillValid = list.some((item) => item.entranceType === this.lgNum);
                        if (!stillValid) {
                            this.changeLgNum(list[0].entranceType);
                        }
                    } else {
                        this.lgNum = null;
                    }
                } else {
                    console.log(res.data && res.data.message);
                    this.entryList = [];
                    this.lgNum = null;
                }
            }).catch((error) => {
                console.log(error);
                this.entryList = [];
                this.lgNum = null;
            }).finally(() => {
                this.entryLoading = false;
            });
        },
        changeLgNum: function (n) {
            if (n === null || n === undefined || n === '') {
                return;
            }
            this.lgNum = Number(n);
        },
        login: function () {
            axios.post('/zhaopinapi/auth/login', {
                username: this.username,
                password: this.password
            }).then((res) => {
                let _d = res.data;
                if(_d.success) {
                    Cookies.set('reqToKen', 'Bearer ' + _d.data.accessToken);
                    window.location.reload();
                }
            }).catch((error) => {
                this.$message.error('登录失效，请重新登录！' + error);
            })
        },
        codeLogin: function () {
            const phone = this.validatePhone();
            if (!phone) {
                return;
            }
            this.validateEntranceOpenTime().then((openOk) => {
                if (!openOk) {
                    return;
                }
                if (!String(this.password || '').trim()) {
                    this.$message.error('请输入验证码');
                    return;
                }
                this.doCodeLogin(phone);
            });
        },
        doCodeLogin(phone) {
            axios.post('/zhaopinapi/auth/login-by-phone', {
                phone: phone,
                code: this.password,
                entrance_type:this.lgNum,
            }).then((res) => {
                const _d = res.data;
                const ok = _d.code === 200 || _d.success === true;
                if (ok && _d.data && _d.data.accessToken) {
                    Cookies.set('reqToKen', 'Bearer ' + _d.data.accessToken);
                    window.location.reload();
                    return;
                }
                const msg = (_d.message != null && String(_d.message).length > 0)
                    ? _d.message
                    : '登录失败，请稍后重试';
                this.showAlert(msg, '提示', {
                    confirmButtonText: '确定',
                    type: 'warning',
                });
            }).catch((error) => {
                let msg = '登录失败，请稍后重试';
                if (error.response && error.response.data && error.response.data.message) {
                    msg = error.response.data.message;
                } else if (error.message) {
                    msg = error.message;
                }
                this.showAlert(msg, '提示', {
                    confirmButtonText: '确定',
                    type: 'error',
                });
            })
        },
        getUserInfo: function (){
            if(Cookies.get('reqToKen')) {
                axios.get('/zhaopinapi/users/info', {
                    headers: {'Authorization': Cookies.get('reqToKen')}
                }).then((res) => {
                    let _d = res.data;
                    if(_d.success) {
                        this.loginFlag = 1;
                        this.userInfo = _d.data;
                        axios.get('/zhaopinapi/job-applications/currently', {
                            headers: {'Authorization': Cookies.get('reqToKen')},
                        }).then((d) => {
                            const _dd = d.data;
                            if (_dd.success && _dd.data) {
                                const latest = _dd.data;
                                const approvalStatus = latest.approvalStatus != null
                                    ? latest.approvalStatus
                                    : latest.approval_status;
                                this.spStatus = this.mapApprovalStatusToSpStatus(approvalStatus);
                            } else {
                                this.spStatus = 0;
                            }
                        }).catch(() => {
                            this.spStatus = 0;
                        })
                    }
                }).catch((error) => {
                    // this.$message.error(error);
                    console.log(error)
                })
            }
        },
        loginOut: function () {
            axios.post('/zhaopinapi/auth/logout', {},{
                headers: {'Authorization': Cookies.get('reqToKen')}
            }).then((res) => {
                let _d = res.data;
                if(_d.success) {
                    // console.log(_d)
                    this.$message.error('已退出账号！');
                    document.cookie = 'reqToKen' + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
                    window.location.reload();
                }
            }).catch((error) => {
                // this.$message.error(error);
                console.log(error)
            })
        },
        /** 校验手机号是否合规 */
        validatePhone() {
            const phone = String(this.username || '').trim();
            if (!phone) {
                this.$message.error('请输入手机号');
                return null;
            }
            if (!PHONE_WHITELIST.includes(phone) && !PHONE_REG.test(phone)) {
                this.$message.error('请输入正确的11位手机号');
                return null;
            }
            return phone;
        },
        /**
         * 请求发送验证码；返回 Promise，resolve 为 true 表示业务成功（可开始倒计时）
         */
        sendCode: function (phone) {
            return axios.post('/zhaopinapi/verification-codes/send', {
                phone: phone
            }).then((res) => {
                const _d = res.data;
                const ok = _d.code === 200 || _d.success === true;
                const text = (_d.message != null && String(_d.message).length > 0)
                    ? _d.message
                    : (ok ? '验证码发送成功' : '验证码发送失败');
                this.showAlert(text, '提示', {
                    confirmButtonText: '确定',
                    type: ok ? 'success' : 'warning',
                });
                return ok;
            }).catch((error) => {
                let msg = '请求失败，请稍后重试';
                if (error.response && error.response.data && error.response.data.message) {
                    msg = error.response.data.message;
                } else if (error.message) {
                    msg = error.message;
                }
                this.showAlert(msg, '提示', {
                    confirmButtonText: '确定',
                    type: 'error',
                });
                return false;
            });
        },
        startCountdown() {
            if (this.isCounting) {
                return;
            }
            const phone = this.validatePhone();
            if (!phone) {
                return;
            }
            if (phone !== this.username) {
                this.username = phone;
            }
            this.validateEntranceOpenTime().then((openOk) => {
                if (!openOk) {
                    return;
                }
                this.sendCode(phone).then((ok) => {
                    if (!ok) {
                        return;
                    }
                    if (this.countdownTimer) {
                        clearInterval(this.countdownTimer);
                        this.countdownTimer = null;
                    }
                    this.isCounting = true;
                    this.countdownTime = 60;
                    this.countdown();
                });
            });
        },
        countdown() {
            this.countdownTimer = setInterval(() => {
                if (this.countdownTime > 0) {
                    this.countdownTime--;
                } else {
                    clearInterval(this.countdownTimer);
                    this.countdownTimer = null;
                    this.isCounting = false;
                    this.countdownTime = 60;
                }
            }, 1000);
        }
    }
}
</script>

<style scoped>
    .jobMain{width: 80%; max-width: 1400px; margin: 0 auto;}
    @media (max-width: 1400px) and (min-width: 1300px) {
        .jobMain{width: 90%;  margin: 0 auto;}
    }
    @media (max-width: 1300px) {
        .jobMain{width: 100%; min-width: 1150px;}
    }
    .pageIndex{
        width: 100%;
        height: 700px;
    }
    .pageIndex--mode-b{
        background: url("../assets/images/loginBg.png") no-repeat center top;
        background-size: 100% 100%;
    }
    .pageIndex--mode-a{
        background-color: #e1e2e5;
        background-image: none;
    }
    .pageIndex .jobMain{
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: flex-start;
        gap: 20px;
    }
    .loginIntro{
        width: 460px;
        height: 570px;
        padding: 70px 24px 0 24px;
        flex-shrink: 0;
        margin-left: -36px;
        background: linear-gradient(to right, rgba(230, 0, 18, 1), rgba(230, 0, 18, 0.4));
        color: #fff;
    }
    .loginIntro-tle{font-size: 27px; line-height: 60px; color: #fff; font-weight: 400; padding-bottom: 10px;}
    .loginIntro-m{font-size: 18px; line-height: 32px; color: #fff; text-indent: 2em; font-weight: 100;}
    .loginIntro-m--test{font-size: 20px; line-height: 36px; text-indent: 0; font-weight: 400; opacity: 0.95;}
    .login-m{
        width: 820px;
        height: auto;
        flex-shrink: 0;
        margin-top: 70px;
        background-color: #fff;
        border-radius: 10px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
    }
    .login-mt{height: 64px; background-color: #C10007; padding: 0 36px; border-top-left-radius: 10px; border-top-right-radius: 10px; font-size: 20px; color: #fff; line-height: 64px;}
    .login-mb{}
    .login-mb-entry-hint{padding: 48px 36px; text-align: center; color: #99A1AF; font-size: 14px; line-height: 22px;}
    .login-mb-l{width: 170px; height: 476px; float: left; background-color: #F9FAFB; border-right: 1px solid #F3F4F6; padding-top: 20px; border-bottom-left-radius: 10px;}
    .login-mb-lg{min-height: 44px; text-align: center; color: #6A7282; font-size: 13px; line-height: 22px; padding: 16px 4px; border-left: 4px solid #F9FAFB; cursor: pointer;}
    .login-mb-lg-label{font-weight: 500;}
    .login-mb-lg-time{margin-top: 6px; font-size: 11px; line-height: 16px; color: #99A1AF; padding: 0 4px; word-break: break-all;}
    .login-mb-lgact{border-left: 4px solid #E7000B; color: #E7000B; box-shadow: 1px 1px 0 0 rgba(0,0,0,0.1); background-color: #fff;}
    .login-mb-lgact .login-mb-lg-time{color: #E7000B; opacity: 0.85;}
    .login-mb-r{margin-left: 170px; padding: 44px 36px 0 36px;}
    .login-mb-rt{font-size: 18px; min-height: 36px; line-height: 28px; font-weight: 600; color: #1E2939; margin-bottom: 4px;}
    .login-mb-rticon{float: left; margin-right: 10px;}
    .login-mb-rt-body{overflow: hidden;}
    .login-mb-rt-title{font-weight: 600; color: #1E2939;}
    .login-mb-rt-time{margin-left: 8px; font-size: 14px; font-weight: 400; color: #6A7282;}
    .login-mb-rtips{color: #99A1AF; font-size: 14px; line-height: 22px; padding-bottom: 12px;}
    .login-mb-rli{padding-bottom: 14px;}
    .login-mb-codeRow{height: 48px;}
    .login-mb-r >>> .el-input__inner{height: 48px; line-height: 48px; font-size: 16px;}
    .login-mb-r >>> .el-input__icon{line-height: 48px;}
    .login-mb-r >>> .el-button--large{padding: 16px 15px;}
    .login-btn{width: 100%; height: 48px; line-height: 48px; cursor: pointer; background-color: #E7000B; font-size: 18px; text-align: center; border: none; border-radius: 4px; color: #fff; font-weight: bold;}
    .login-btn:hover{background-color: #C10007;}
    .login-m-avatar{padding-top: 30px; text-align: center;}
    .avatar-circle{width: 60px; height: 60px; display: inline-block; margin: 0 auto; border-radius: 32px; border: 2px solid #FFE2E2; background: #F3F4F6; position: relative;}
    .avatar-login-success{width: 16px; height: 16px; border-radius: 8px; background: #00C950; display: block; position: absolute; left: 44px; top: 44px;}
    .avatar-userName{text-align: center; font-size: 18px; font-weight: bold; color: #1E2939; line-height: 36px;}
    .avatar-userId{text-align: center; font-size: 12px; color: #6A7282; line-height: 24px;}
    .job-link{padding: 12px 0;}
    .job-link-btn{height: 48px; line-height: 48px; border: none; border-radius: 4px; background: #E7000B; color: #fff; font-weight: bold; font-size: 16px; display: block; text-align: center; text-decoration: none;}
    .job-link-btn:hover{background: #C10007;}
    .login-status-1{height: 32px; line-height: 32px; padding: 0 12px; margin-top: 20px; border-radius: 4px;}
    .ls1-tle{float: left; line-height: 32px; color: #6A7282; font-size: 12px;}
    .ls10{border: 1px solid rgba(0, 0, 0, 0.10);}
    .ls11{border: 1px solid #155DFC;}
    .ls12{border: 1px solid #E7000B;}
    .ls13{border: 1px solid #00A63E;}
    .ls14{border: 1px solid rgba(0, 0, 0, 0.10);}
    .ls1-r{float: right; line-height: 32px; color: #6A7282; font-size: 12px;}
    .ls1-r5{color: #D97706;}
    .ls1-r1{color: #155DFC;}
    .ls1-r2{color: #E7000B;}
    .ls1-r3{color: #00A63E;}
    .ls1-r4{color: #6A7282;}
    .login-status-2{padding: 24px 0; height: 20px; border-top: 1px solid #E5E7EB; border-bottom: 1px solid #E5E7EB;}
    .ls2-list{height: 20px; margin: 0; padding: 0; list-style: none;}
    .ls2-list li{width: 16.666%; float: left; box-sizing: border-box; padding: 0 2px;}
    .ls2-libox{border-radius: 4px; background: #F9FAFB; color: #99A1AF; font-size: 12px; display: block; text-align: center; line-height: 20px;}
    .ls25{background: #FEF3C7; color: #B45309;}
    .ls20{background: #E5E7EB; color: #0A0A0A;}
    .ls21{background: #DBEAFE; color: #1447E6;}
    .ls22{background: #FFE2E2; color: #C10007;}
    .ls23{background: #DCFCE7; color: #008236;}
    .ls24{background: #E5E7EB; color: #4A5565;}
    .loginOut{height: 16px; line-height: 16px; text-align: center; font-size: 14px; color: #99A1AF; cursor: pointer; padding: 16px 0;}
    .loginOut:hover{color: #2A2C31;}
</style>
